const $j =
    typeof window !== 'undefined' && window.jQuery
        ? window.jQuery.noConflict()
        : () => {};

window.$j = $j;
window.resizerfn = null;
window.scrollerfn = null;
window._rps = 100;
window._sps = 100;
window.scrolledtop = 250;
window.loader_delay = 200;
window.loader_fadeout = 300;
window.msizer = $j('#msizer');
window.body = $j('body');
